import type { ColumnDef } from '@tanstack/react-table';
import { ActionIcon, Badge, Text, Tooltip } from '@mantine/core';
import { IconEye } from '@tabler/icons-react';
import type { IDesgloseCostoEquipo } from '../../../modelos/CotizadorServicios/entidades/IResultadoCotizacionServicios';
import { formatoMoneda } from '../interfaces';

const columnaMoneda = (campo: keyof IDesgloseCostoEquipo & string, encabezado: string, negrita = false): ColumnDef<IDesgloseCostoEquipo> => ({
    accessorKey: campo,
    header: encabezado,
    cell: ({ row }) => <Text size="xs" fw={negrita ? 700 : undefined} ta="right">{formatoMoneda(row.original[campo] as number)}</Text>
});

/** Columnas del desglose interno de costos (hoja "Calculador"). */
export const columnasDesgloseServicios = (alVerDetalle: (equipo: IDesgloseCostoEquipo) => void): ColumnDef<IDesgloseCostoEquipo>[] => [
    {
        id: 'actions',
        header: 'Ver',
        cell: ({ row }) => (
            <Tooltip label="Ver desglose" withinPortal zIndex={9999} style={{ fontSize: '10px', padding: '3px 5px' }}>
                <ActionIcon variant="transparent" color="var(--mantine-color-primary-0)" size="sm" onClick={() => alVerDetalle(row.original)}>
                    <IconEye size={18} />
                </ActionIcon>
            </Tooltip>
        )
    },
    {
        accessorKey: 'Referencia',
        header: 'Equipo',
        cell: ({ row }) => <Text size="xs" fw={600}>{row.original.Referencia}</Text>
    },
    {
        accessorKey: 'EsAscensor',
        header: 'Familia',
        cell: ({ row }) => (
            <Badge size="xs" variant="light" style={{ textTransform: 'none' }}>
                {row.original.EsAscensor ? 'Ascensor' : 'Escalera'}
            </Badge>
        )
    },
    { accessorKey: 'Cantidad', header: 'Cant.', cell: ({ row }) => <Text size="xs">{row.original.Cantidad}</Text> },
    columnaMoneda('TotalCostoBase', 'Costo base total'),
    columnaMoneda('CostoCif', 'CIF'),
    columnaMoneda('CostosEspeciales', 'Costos especiales'),
    columnaMoneda('SubtotalConIncremento', 'Subtotal + incr. anual'),
    columnaMoneda('PrecioUnitario', 'Precio unitario'),
    columnaMoneda('Descuento', 'Descuento'),
    columnaMoneda('Incremento', 'Incremento'),
    columnaMoneda('PrecioFinalUnitario', 'Precio final unitario', true),
    columnaMoneda('PrecioTotal', 'Precio total', true)
];
